import { render, staticRenderFns } from "./seeParams.vue?vue&type=template&id=2c084637&scoped=true"
import script from "./seeParams.vue?vue&type=script&lang=js"
export * from "./seeParams.vue?vue&type=script&lang=js"
import style0 from "./seeParams.vue?vue&type=style&index=0&id=2c084637&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c084637",
  null
  
)

export default component.exports